<template>
   <!-- <div> -->
    <div class="page-content">
      <div class="inner">
        <div class="card-contents">
          <div class="flexcenter">
            <div class="cover-image"><img :src="getContentsThumbnailPath(contentsDetail.contentid, showScreen) " :alt="contentsDetail.content_name"></div>
            <div class="detail-content">
              <div class="flexbetween">
                <div class="content-name font28" v-html="getContentName()" />
              </div>
              <div v-if="!isAu(platformName)" class="content">
                <div class="rate">
                  <span v-if="contentsDetail.progress == 100">★</span>
                </div>
                <div class="progress">
                  <p>学習進捗状況</p>
                  <div class="flexbox">
                    <div class="progress-bar">
                      <div class="data" :style="{ width: contentsDetail.progress + '%' }" />
                    </div>
                    <div class="percentage font14">{{ contentsDetail.progress }}%</div>
                  </div><!-- flexbox -->
                </div><!-- progress -->
              </div><!-- content -->
              <div class="content-button">
                <button @click="goContentsHome">学習をはじめる</button>
              </div>
            </div><!-- detail-content -->
          </div><!-- flexcenter -->
        </div><!-- card-contents -->
      </div><!-- inner -->
    </div><!-- page-content -->
  <!-- </div> -->
</template>

<script>
import common from "@/mixin/common";
import * as constants from "@/mixin/constants";

export default {
  name: "purchasedDetail",
  data: function() {
    return {
      showScreen: "PurchasedDetail"
    };
  },
  mixins: [
    common
  ],
  props: {
    contentsDetail: Object,
    platformName: String
  },
  created: function() {
    this.log("PurchasedDetail start created");
    this.$emit("setViewName", "学習");
  },
  mounted: function() {
    this.log("PurchasedDetail start mounted");
  },
  methods: {
    /**
     * コンテンツのホーム画面へ遷移する
     */
    goContentsHome: function() {
      // GoogleAnalyticsイベントヒット送信
      rosettaGA.sendEvent(
        this.getGaEventCategoryByPlatformName(constants.GA_EVENT.GATEGORY.LEARNING_DETAIL, this.platformName),
        constants.GA_EVENT.ACTION.CLICK,
        this.contentsDetail.content_name,
        [this.contentsDetail.contentid]
      );

      var url = this.contentsDetail.homeurl;
      this.log("PurchasedDetail start goContentsHome: " + url);
      window.location.assign(url);
    },
    /**
     * コンテンツ名を取得
     */
    getContentName: function() {
      var name = this.contentsDetail.content_name;
      if (this.isAu(this.platformName)) {
        // auの場合、置き換える
        if (this.contentsDetail.contentid == constants.CONTENTS_ID_PRIVATE1) {
          name = constants.AU_PRIVATE1_CONTENTS_NAME;
        }
      }

      return name;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/common";
@import "src/assets/style/study";
</style>



// WEBPACK FOOTER //
// PurchasedDetail.vue?10acb867